<!--
  Kommerzielle Landingpage „Lebensmittelautomat kaufen“. Muster wie Eier-/Hofladen-Seite.
  Spielerei: Korb, in den nacheinander Produkte fallen (eins in Marken-Orange).
-->
<section class="lma-hero">
  <div class="content content--wide lma-hero__grid">
    <div class="lma-hero__text reveal">
      <!-- Korb-Füll-Animation (reine CSS/SVG, reduced-motion-sicher). Dekorativ → aria-hidden. -->
      <div class="lma-basket" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <g class="lma-basket__items">
            <circle class="lma-basket__item lma-basket__item--a" cx="41" cy="58" r="8" />
            <circle class="lma-basket__item lma-basket__item--b" cx="57" cy="56" r="7" />
            <ellipse class="lma-basket__item lma-basket__item--c" cx="49" cy="61" rx="9" ry="5.5" />
          </g>
          <g class="lma-basket__body">
            <path d="M20,62 L80,62 L73,89 L27,89 Z" />
            <line x1="18" y1="62" x2="82" y2="62" />
            <line x1="35" y1="62" x2="39" y2="89" />
            <line x1="50" y1="62" x2="50" y2="89" />
            <line x1="65" y1="62" x2="61" y2="89" />
          </g>
        </svg>
      </div>
      <span class="lma-eyebrow" i18n="@@lma.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@lma.hero.h1">Lebensmittelautomat kaufen</h1>
      <div class="line"></div>
      <p class="lma-lead" i18n="@@lma.hero.lead">
        Verkaufe regionale Lebensmittel rund um die Uhr – ohne Ladenöffnungszeiten und Personal vor Ort.
        Die <span class="tm">marktbox</span> ist dein Lebensmittelautomat für die Direktvermarktung:
        bargeldlos, app-gesteuert und wetterfest im Einsatz.
      </p>
      <div class="lma-cta">
        <a class="btn btn-primary lma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@lma.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lma-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@lma.hero.ctaGhost">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="lma-hero__media reveal">
      <img src="assets/headers/marktbox-02-1440.webp"
        alt="marktbox Lebensmittelautomat für regionale Direktvermarktung" i18n-alt="@@lma.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lma-hero__badge" i18n="@@lma.hero.badge">🧺 regional &amp; frisch</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="lma-section">
  <div class="content content--wide">
    <h2 class="lma-h2 reveal" i18n="@@lma.adv.h2">Warum die marktbox als Lebensmittelautomat?</h2>
    <div class="lma-grid">
      <div class="lma-card reveal">
        <span class="lma-card__ico">🕒</span>
        <h3 i18n="@@lma.adv.c1.h">24/7 verkaufen</h3>
        <p i18n="@@lma.adv.c1.p">Deine Kundschaft kauft frische Lebensmittel, wann sie will – auch abends, sonntags und feiertags.</p>
      </div>
      <div class="lma-card reveal">
        <span class="lma-card__ico">💳</span>
        <h3 i18n="@@lma.adv.c2.h">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@lma.adv.c2.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand vor Ort.</p>
      </div>
      <div class="lma-card reveal">
        <span class="lma-card__ico">🧺</span>
        <h3 i18n="@@lma.adv.c3.h">Breites Sortiment</h3>
        <p i18n="@@lma.adv.c3.p">Eier, Kartoffeln, Backwaren, Honig, Marmelade, Nudeln – lagerfähige Lebensmittel rund um die Uhr.</p>
      </div>
      <div class="lma-card reveal">
        <span class="lma-card__ico">🚜</span>
        <h3 i18n="@@lma.adv.c4.h">Direkt vom Erzeuger</h3>
        <p i18n="@@lma.adv.c4.p">Verkaufe ohne Zwischenhandel – mit voller Kontrolle über Preis, Auswahl und Präsentation.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="lma-section lma-live">
  <div class="content content--wide lma-live__grid">
    <div class="lma-live__text reveal">
      <span class="lma-eyebrow" i18n="@@lma.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lma-h2" i18n="@@lma.live.h2">Sieh, was gerade in der Box ist</h2>
      <p class="lma-lead" i18n="@@lma.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, welche
        Lebensmittel gerade verfügbar sind – noch bevor sie losfährt. Das schafft Vertrauen,
        spart unnötige Wege und bringt mehr Verkäufe.
      </p>
      <ul class="lma-live__list">
        <li i18n="@@lma.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@lma.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@lma.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lma-cta">
        <a class="btn btn-primary lma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@lma.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link: Echtzeit-Verfügbarkeit der Lebensmittel-Box" i18n-title="@@lma.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@lma.live.cap">Live-Beispiel: Obsthof Zink</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lma-section lma-section--muted">
  <div class="content content--wide">
    <h2 class="lma-h2 reveal" i18n="@@lma.price.h2">Lebensmittelautomat kaufen oder mieten</h2>
    <div class="lma-price-grid">
      <div class="lma-price reveal">
        <span class="lma-price__label" i18n="@@lma.price.buyLabel">Kaufen</span>
        <span class="lma-price__value" i18n="@@lma.price.buyValue">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@lma.price.buyP">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="lma-price reveal">
        <span class="lma-price__label" i18n="@@lma.price.rentLabel">Mieten</span>
        <span class="lma-price__value" i18n="@@lma.price.rentValue">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@lma.price.rentP">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="lma-cta lma-cta--center reveal">
      <a class="btn btn-primary lma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@lma.price.cta">Zum Shop – Lebensmittelautomat konfigurieren</a>
    </div>
    <p class="lma-fineprint reveal" i18n="@@lma.price.fineprint">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogSlug]">Im Ratgeber: Lebensmittel verkaufen – Auflagen &amp; Vorschriften</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="lma-section">
  <div class="content content--wide">
    <h2 class="lma-h2 reveal" i18n="@@lma.models.h2">Passende Modelle</h2>
    <div class="lma-models">
      <a class="lma-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="lma-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Lebensmittelautomat mit 39 Fächern" i18n-alt="@@lma.models.m39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lma-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@lma.models.m39.p">39 Fächer – für ein breites Sortiment und höhere Stückzahlen.</p>
          <span class="lma-model__more" i18n="@@lma.models.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="lma-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="lma-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Lebensmittelautomat mit 24 Fächern" i18n-alt="@@lma.models.m24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lma-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@lma.models.m24.p">24 Fächer – kompakter Einstieg für die Direktvermarktung.</p>
          <span class="lma-model__more" i18n="@@lma.models.more2">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lma-section lma-section--muted">
  <div class="content content--wide">
    <h2 class="lma-h2 reveal" i18n="@@lma.faq.h2">Häufige Fragen zum Lebensmittelautomat</h2>
    <div class="lma-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lma-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="lma-fineprint reveal" i18n="@@lma.faq.fineprint">
      Mehr Praxiswissen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogSlug]">Selbstgemachte Lebensmittel verkaufen</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lma-section lma-final reveal">
  <div class="content content--wide">
    <h2 class="lma-h2" i18n="@@lma.final.h2">Bereit für deinen Lebensmittelautomaten?</h2>
    <p class="lma-lead" i18n="@@lma.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="lma-cta lma-cta--center">
      <a class="btn btn-primary lma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@lma.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
